import React from 'react';
import styled from 'styled-components';
import Carousel from './Carousel';

const ShopContainer = styled.div`
  width: 100%;
  background: url('/img/bg.jpg');
  height: 450px;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;

  @media (max-width: 768px) {
    height: 300px;
  }
`;

const ShopContent = styled.div`
  text-align: center;
`;

const Heading1 = () => {
  return (
    <ShopContainer>
      <ShopContent className="container">
        <Carousel/>
      </ShopContent>
    </ShopContainer>
  );
};

export default Heading1;
